import { CSSObject } from '@chakra-ui/react';

export const GreenIDContainer: CSSObject = {
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  maxW: ['100vw', null, '800px'],
  bg: 'alpha.400',
  'button#greenid-option-list-toggle': {
    h: '38px',
    borderRadius: 'base',
    bg: 'blackAlpha.500',
    color: 'white',
    border: 'none',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
    ':hover': {
      bg: 'blackAlpha.600',
    },
  },
  '#greenid-source-header #greenid-source-title': {
    '&&': {
      '#greenid-source-title-heading': {
        color: 'white',
        fontWeight: 'medium',
        fontSize: 'sm',
        fontFamily: 'roboto',
      },
    },
    'a.greenid-modal-launch': {
      position: 'relative',
      p: '0',
      px: '2',
      '.glyphicon-question-sign': {
        color: 'beta.300',
      },
    },
  },
  '#greenid-intro-words': {
    '.lead': {
      color: 'white',
      fontSize: 'xs',
      fontWeight: 'normal',
    },
  },
  '#greenid-intro-content': {
    h1: {
      color: 'beta.300',
      textShadow: '0 0 8px rgba(254, 208, 119, 0.50)',
      fontSize: '14px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    p: {
      color: 'white',
      fontWeight: 'normal',
      fontSize: 'sm',
      fontFamily: 'roboto',
    },
  },
  '&&': {
    '#greenid-container': {
      bg: 'unset',
      h2: {
        color: 'white',
      },
      a: {
        color: 'white',
      },
      '.greenid-helpicon': {
        color: 'beta.300',
      },
      '.btn-default': {
        ':hover': {
          color: 'white',
        },
      },
      '.btn-primary': {
        position: 'relative',
        borderRadius: 'md',
        border: 'none',
        bgGradient: 'linear(180deg, beta.300 0%, beta.400 100%)',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        fontFamily: 'accent',
        fontSize: 'xs',
        fontWeight: 'bold',
        textTransform: 'capitalize',
        textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
        _hover: {
          bgGradient: 'linear(180deg, beta.300 0%, beta.400 100%)',
          color: 'beta.700',
          _after: {
            bgGradient: 'linear(180deg, beta.400 0%, beta.400 100%)',
          },
        },
        ':active': {
          bgGradient: 'linear(180deg, alpha.800 0%, alpha.800 100%)',
          boxShadow:
            '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
          color: 'beta.300',
          textShadow: '0px 0px 8px rgba(255, 210, 123, 0.5)',

          _after: {
            display: 'none',
          },
        },
        '&[data-active=false]': {
          bgGradient: 'linear(180deg, beta.300 0%, beta.400 100%)',
        },
        _disabled: {
          opacity: 0.4,
          pointerEvents: 'none',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        },

        '&&&': {
          '& > svg, & > span': { zIndex: 9 },
        },
      },
      '#greenid-source-header': {
        display: 'flex',
        flexDirection: 'column',
        margin: '0',
        marginTop: '10px',
        '#greenid-source-title': {
          display: 'flex',
          '#greenid-source-title-heading': {
            marginTop: '10px',
          },
          '#greenid-modal-launch': {},
          '#greenid-source-help': {
            '.modal-dialog': {
              '.modal-body': {
                marginLeft: '3',
              },
            },
          },
        },
      },
      '#greenid-source-content': {
        borderTop: '1px solid',
        boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07) inset',
        borderTopColor: 'blackAlpha.500',
        '#greenid-source-body': {
          p: {
            color: 'white',
            strong: {
              color: 'white',
            },
          },
          '.row': {
            '.form-group': {
              select: {
                h: '38px',
                borderRadius: 'base',
                bg: 'blackAlpha.500',
                color: 'white',
                border: 'none',
                boxShadow:
                  '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
                option: {
                  color: 'black',
                },
              },
              '.control-label': {
                color: 'white',
              },
              'label[for="greenid-bdm-stateselect"]': {
                color: 'white',
              },
              label: {
                color: 'black',
                fontWeight: 'medium',
                fontSize: 'sm',
                fontFamily: 'roboto',
                span: {
                  color: 'white',
                  fontWeight: 'medium',
                  fontSize: 'sm',
                  fontFamily: 'roboto',
                },
              },
              'input[type="text"]': {
                borderLeftRadius: 'base',
                bg: 'blackAlpha.500',
                boxShadow:
                  '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
                border: 'none',
                color: 'white',
                fontWeight: 'normal',
                '&&:hover, &&:focus': {
                  bg: 'blackAlpha.400',
                },
                _placeholder: {
                  color: 'white',
                },
                h: '38px',
              },
            },
          },
          '.checkbox': {
            'input[type="checkbox"]': {
              width: '20px',
              height: '20px',
              bg: 'alpha.400',
              borderWidth: '2px',
              borderColor: 'gray.200',
              marginLeft: '-28px',
              borderRadius: 'sm',

              '&[data-checked]': {
                width: '20px',
                height: '20px',
                bg: 'alpha.400',
                borderColor: 'alpha.400',
              },
              '&[data-checked]:hover': {
                width: '20px',
                height: '20px',
                bg: 'alpha.400',
                borderColor: 'alpha.400',
              },
            },
            label: {
              fontSize: 'xs',
              color: 'white',
              paddingLeft: '28px',
            },
          },
        },
      },
      '.input-group-addon': {
        bg: 'blackAlpha.500',
        border: 'none',
        boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
        '.glyphicon-calendar': {
          color: 'beta.300',
        },
      },
    },
  },
  '#greenid-submit-button-container #greenid-submit': {
    color: 'beta.500',
    ':active': {
      color: 'beta.300',
    },
  },
};
